module.exports = __webpack_public_path__ + "static/media/rec.52bb94b8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rec.gif
// module id = 151
// module chunks = 0